module.exports = __webpack_public_path__ + "media/img/pages/companies/audemars-cbe9a9801ce77955acd82a2391902d01.webp";